var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 50,
    viewBox: "0 0 48 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5087 5.67509C8.19167 5.67509 5.49453 8.54294 5.49453 12.07C5.49453 30.2412 19.3989 45.0281 36.4909 45.0281C39.8057 45.0281 42.5051 42.1603 42.5051 38.6333C42.5051 38.3603 42.4889 38.0922 42.4566 37.8265L31.7697 35.2194C31.5569 35.6523 31.3233 36.1221 31.1105 36.5599C30.0557 38.6997 29.2923 40.2541 27.3447 39.4203C19.6973 36.5672 13.4541 29.9264 10.7362 21.6967C9.91035 19.7659 11.4833 18.8903 13.4773 17.7835C13.8821 17.5573 14.3192 17.3138 14.7194 17.0924L12.2675 5.72674C12.0107 5.69231 11.7609 5.67509 11.5087 5.67509ZM36.4914 49.9491C16.848 49.9491 0.868652 32.9584 0.868652 12.0718C0.868652 5.8319 5.64071 0.757812 11.5092 0.757812C12.1106 0.757812 12.7051 0.811923 13.2811 0.917684C13.8432 1.01361 14.4076 1.1661 14.9581 1.36778C15.7099 1.64572 16.2766 2.31718 16.4547 3.14359L19.6215 17.8124C19.7973 18.6192 19.5775 19.4653 19.0362 20.0654C18.7216 20.4147 18.7147 20.422 15.8464 22.0183C18.1688 27.3654 22.2053 31.6426 27.1323 34.0284C28.6359 30.976 28.6451 30.9662 28.9736 30.6317C29.538 30.0562 30.3384 29.8323 31.0924 30.0094L44.8905 33.3766C45.6654 33.566 46.2969 34.1661 46.5559 34.9654C46.7456 35.5459 46.889 36.146 46.9839 36.7634C47.081 37.3709 47.1319 38.0005 47.1319 38.6351C47.1319 44.875 42.3575 49.9491 36.4914 49.9491Z",
    fill: "#009999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.4d27fb05d40d66c1ad7a4649e2efc548.svg";
export { ForwardRef as ReactComponent };